

(function dynamicModuleDefinition() {

    'use strict';

    angular.module('Dynamic', ['oc.lazyLoad', 'Auth', 'Config'])
        .provider('dynamic', function dynamicProvider() {

            var svc = {
                redirectUrl: null,
                setRedirectUrl: function(url) {
                    this.redirectUrl = url;
                }
            };
            this.setRedirectUrl = function setRedirectUrl(url) {
                svc.redirectUrl = url;
            };

            this.$get = function dynamicService() {
                return svc;
            };
        })
        .config([
            'authProvider', function dynamicModuleConfig(authProvider) {

                authProvider.onIdentityChanged([
                    '$ocLazyLoad', 'config', '$location', 'cached', 'dynamic', '$rootScope',
                    function ($ocLazyLoad, config, $location, cached, dynamic, $rootScope) {

                        // este método se ejecuta con el this seteado en el servicio de auth
                        // no se inyecta para evitar una dependencia circular.
                        if (this.isLogged()) {
                            var resources = this.getResources();

                            // primero cargo el/los archivo/s y luego los modulos del mismo.
                            if (resources) {
                                var modules = [];

                                for (var i = 0; i < resources.length; i++) {

                                    var bundleInfo = resources[i];

                                    modules.push({
                                        serie: true,
                                        files: bundleInfo.Urls.map(function(url) {
                                            return config.appAbsoluteUrl(url);
                                        })
                                    });
                                }

                                $ocLazyLoad.load(modules).then(function() {

                                    var counter = 0;

                                    for (var i = 0; i < resources.length; i++) {

                                        var bundleInfo = resources[i];

                                        if (bundleInfo.Modules) {
                                            var loadModules = bundleInfo.Modules.map(function(moduleName) {
                                                return { name: moduleName, files: [] };
                                            });

                                            $ocLazyLoad.load(loadModules).then(function() {

                                                if (++counter == resources.length) {

                                                    var hasRedirect = false;

                                                    if (dynamic.redirectUrl) {
                                                        if (cached) {
                                                            // chequeo si el estado existe ahora que se cargó todo
                                                            $location.url(dynamic.redirectUrl);
                                                            hasRedirect = true;
                                                        }
                                                        dynamic.redirectUrl = null;
                                                    }

                                                    $rootScope.$broadcast('dynamic.loadFinished', hasRedirect);
                                                }

                                            }, function(err) {
                                                console.log('LazyLoad: ' + err.message + '\n' + err.stack);
                                            });
                                        }
                                    }

                                }, function(err) {
                                    console.log('LazyLoad: ' + err.message + '\n' + err.stack);
                                });
                            }
                        }

                    }
                ]);
            }
        ]);

})();